// extracted by mini-css-extract-plugin
module.exports = {"footer":"Pagination_footer__TVbDf","pagination":"Pagination_pagination__1Z03K","activePage":"Pagination_activePage__3R7k6","directPagination":"Pagination_directPagination__1_696"};